interface IConfig {
  payment_source_required: boolean;
}

declare const CONFIG: IConfig;

export const PAYMENT_SOURCE_REQUIRED = CONFIG.payment_source_required;
